<template>
  <b-container>
    <b-form-group :label="$t('geral.displayName')" label-for="sidebarTitle">
      <b-form-input
        id="sidebarTitle"
        type="text"
        placeholder="Informe o nome de exibição"
        v-model="model.sidebarTitle"
      />
      <span class="text-danger" v-if="modelstate['SidebarTitle']">
        {{ modelstate["SidebarTitle"][0] }}
      </span>
    </b-form-group>

    <b-form-group :label="$t('bi.powerbiview.embendedCode')" label-for="embendedCode">
      <b-form-textarea
        id="embendedCode"
        v-model="model.embendedCode"
        style="height: 20rem"
      ></b-form-textarea>
      <span class="text-danger" v-if="modelstate['EmbendedCode']">
        {{ modelstate["EmbendedCode"][0] }}
      </span>
    </b-form-group>

    <!-- {{ model }} -->
  </b-container>
</template>

<script>
export default {
  name: "PowerBIViewCrudData",
  // components: {
  //   FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
  //   SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  //   CrudData: () => import("@/components_rms/System/Profile/CrudData.vue"),
  // },
  props: {
    model: Object,
    modelstate: Object,
  },
//   data() {
//     return {
//       optionsBoolean: [
//         { value: true, text: "Sim" },
//         { value: false, text: "Não" },
//       ],
//     };
//   },
};
</script>
